var CoverGridVariables     = require("app/theme/styles/repeaters/CoverGridVariables"),
    ThumbnailGridVariables = require("app/theme/styles/repeaters/ThumbnailGridVariables"),
    themeVars              = require("app/theme/variables");

module.exports = {

    /**
     * The maximum width of a column in pixels.
     *
     * @returns  {number}  The maximum width
     * @public
     */
    maxColWidth: function() {
        var viewportWidth   = this.getOption("viewportWidth"),
            padLeft         = this.getOption("padLeft"),
            padRight        = this.getOption("padRight"),
            colSpacing      = this.getOption("colSpacing"),
            repeater        = this.repeater,
            childFormat     = repeater.get("childFormat"),
            childFormFactor = repeater.get("childFormFactor"),
            childSize       = repeater.get("childSize"),
            availableWidth,
            maxColWidth,
            minColumns;

        availableWidth = viewportWidth
            + colSpacing // One colSpacing worth of overflow
            - padLeft // Compensate for left padding
            - padRight; // Compensate for right padding

        switch (childFormat) {
            case "thumbnail":
                maxColWidth = ThumbnailGridVariables.getMaxColWidth(childFormFactor, childSize);
                minColumns  = ThumbnailGridVariables.getMinColumns(childFormFactor, childSize);
                break;
            case "cover":
            default:
                maxColWidth = CoverGridVariables.getMaxColWidth(childFormFactor, childSize);
                minColumns  = CoverGridVariables.getMinColumns(childFormFactor, childSize);
                break;
        }

        return Math.min(
            availableWidth / minColumns,
            maxColWidth
        );
    },

    /**
     * The grid will not be allowed to expand indefinitely along the y axis.
     *
     * @return {number}  The maximum height of the grid in pixels
     * @public
     */
    maxGridHeight: Infinity,

    /**
     * Whether to round values of cell width/height and arrangement transform to
     * integer pixels values.
     *
     * @type    {boolean}
     * @public
     */
    roundPixels: true,

    /**
     * The amount of spacing between columns.
     *
     * @return  {number}  The amount of spacing
     * @public
     */
    colSpacing: function() {
        return themeVars.getGridInnerSpacingHorizontalPx();
    },

    /**
     * The amount of spacing between rows.
     *
     * @return  {number}  The amount of spacing
     * @public
     */
    rowSpacing: function() {
        return themeVars.getGridInnerSpacingVerticalPx();
    },

    /**
     * The amount of padding the top of the grid.
     *
     * @return {number}  The padding
     * @public
     */
    padTop: 0,

    /**
     * The amount of padding the bottom of the grid.
     *
     * @return {number}  The padding
     * @public
     */
    padBottom: 0,

    /**
     * The amount of padding the left of the grid.
     *
     * @return {number}  The padding
     * @public
     */
    padLeft: function() {
        return Math.max(themeVars.safeAreaInsetLeft + themeVars.getPageMarginPx(), themeVars.getPageMarginLargePx());
    },

    /**
     * The amount of padding the right of the grid.
     *
     * @return {number}  The padding
     * @public
     */
    padRight: function() {
        return themeVars.safeAreaInsetRight + themeVars.getPageMarginPx();
    }
};
